import { useEffect } from "react";
import "@/App.css";
import axios from "axios";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useLenis } from "@/hooks/useLenis";
import { ProgressProvider } from "@/context/ProgressContext";
import { AccessProvider } from "@/context/AccessContext";
import { ProgressBar } from "@/components/ProgressBar";
import { Celebration } from "@/components/Celebration";
import Landing from "@/pages/Landing";
import LessonPage from "@/pages/LessonPage";
import AdminLeads from "@/pages/AdminLeads";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Layout({ children }) {
  useLenis();
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="App paper-grain min-h-screen bg-[#FBFBF9]">
      {children}
      {!isAdmin && <ProgressBar />}
      {!isAdmin && <Celebration />}
    </div>
  );
}

function App() {
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/`).catch(() => {});
  }, []);

  return (
    <BrowserRouter>
      <ProgressProvider>
        <AccessProvider>
          <Layout>
            <ScrollManager />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/learn/:chapterId" element={<LessonPage />} />
              <Route path="/admin/leads" element={<AdminLeads />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </AccessProvider>
      </ProgressProvider>
    </BrowserRouter>
  );
}

export default App;
